import { Campaign } from 'src/features/campaignBanner/parseCampaigns'
import { appEnv } from 'src/util/appEnv'

/**
 * 遷移先で「どのプロダクトから来たか」を集計するための識別子。
 * カミナシ レポートは report。
 */
const APP_ID = 'report'

/**
 * キャンペーンの遷移先 URL を組み立てる。
 *
 * アクセス解析のためのUTM パラメータを付けるのは本番のみ。開発環境からのアクセスが
 * キャンペーンの集計に混ざらないようにする。
 */
export const buildCampaignLink = (campaign: Campaign): string => {
  if (!appEnv.isProduction) return campaign.link

  // link は parseCampaigns で https の URL であることを保証している
  const url = new URL(campaign.link)
  url.searchParams.set('utm_source', 'product')
  url.searchParams.set('utm_medium', APP_ID)
  url.searchParams.set('utm_campaign', campaign.campaignId)

  return url.toString()
}
